var _path, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9284 14.9566C34.9182 14.9415 34.9041 14.9294 34.8876 14.9217C32.9739 14.0289 30.9298 13.3771 28.7938 13.0008C28.7518 12.9934 28.7098 13.0134 28.6894 13.0508C28.4431 13.5026 28.1646 14.0821 27.961 14.5627C27.9431 14.605 27.8989 14.6298 27.8535 14.6231C25.5984 14.2915 23.3635 14.2914 21.1489 14.6229C21.1034 14.6297 21.0591 14.6049 21.0411 14.5625C20.837 14.0818 20.5523 13.5022 20.3035 13.0504C20.283 13.0132 20.2412 12.9934 20.1994 13.0007C18.0609 13.3771 16.0145 14.0312 14.1007 14.9263C14.084 14.9341 14.0698 14.9465 14.0596 14.9618C10.1656 20.8573 9.10271 26.6069 9.6233 32.275C9.62589 32.3032 9.64048 32.3291 9.66317 32.3459C12.2245 34.2524 14.708 35.4197 17.1499 36.1877C17.1908 36.2005 17.2352 36.1857 17.2603 36.151C17.8331 35.3563 18.3471 34.5147 18.7944 33.6302C18.8211 33.5775 18.796 33.5133 18.7409 33.4919C17.9308 33.1776 17.1523 32.7979 16.4123 32.362C16.3509 32.3259 16.3467 32.2389 16.4034 32.1958C16.5595 32.0773 16.7129 31.9551 16.8625 31.8302C16.8924 31.8052 16.9343 31.7997 16.9696 31.8161C21.8703 34.0888 27.1878 34.0889 32.0305 31.8164C32.0657 31.7998 32.1076 31.805 32.1376 31.8299C32.2888 31.9549 32.4425 32.0772 32.5976 32.1959C32.654 32.239 32.6496 32.3256 32.5885 32.3616C31.846 32.7998 31.065 33.1798 30.2544 33.4943C30.1992 33.5157 30.1741 33.5799 30.2009 33.6327C30.648 34.5152 31.16 35.3589 31.7349 36.1535C31.76 36.1882 31.8043 36.2029 31.8452 36.1901C34.2894 35.4221 36.7753 34.2548 39.3368 32.3459C39.3595 32.329 39.374 32.303 39.3766 32.2749C39.9869 25.7075 38.3059 20.0102 34.9284 14.9566Z",
    stroke: "#9BE7C4",
    strokeWidth: 1.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5312,
    cy: 25.7292,
    rx: 2.40625,
    ry: 2.84375,
    fill: "#9BE7C4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 25.7292,
    rx: 2.40625,
    ry: 2.84375,
    fill: "#9BE7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8067893cc6d59ea2f38eca000f8e8905.svg";
export { ForwardRef as ReactComponent };